import { defineComponent as _defineComponent } from 'vue'
import AudioPlayer from '@/components/AudioPlayer.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import type { PropType } from 'vue'
  import type { AudioFile } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AudioLesson',
  props: {
    audioFiles: {
      type: Array as PropType<AudioFile[]>,
      required: true,
    },
    content: {
      type: String,
    },
    formatContent: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

  

return { __sfc: true,AudioPlayer, HTMLRenderer }
}

})